import { CSSObject } from "@emotion/react";

import { Article } from "@/types/models";
import ContentLevel from "@/types/models/ContentLevel.interface";
import useUserContentUIContext from "@/view/utils/useUserContentUIContext";
import { headerMediaCss } from "./ContentDisplayHeaderMedia.style";
import { articleHasHeaderImage } from "./ContentDisplayHeaderMedia.utils";
import HeaderMediaImage from "./HeaderMediaImage";

interface ContentDisplayHeaderMediaProps {
  contentData: Article;
  currentLevel: ContentLevel;
  styleOverrides?: CSSObject | undefined;
}

const ContentDisplayHeaderMedia = ({
  contentData,
  currentLevel,
  styleOverrides,
}: ContentDisplayHeaderMediaProps) => {
  const { uiType } = useUserContentUIContext();
  const hasHeaderImage = articleHasHeaderImage(contentData);

  return !hasHeaderImage ? null : (
    <div css={[headerMediaCss(uiType), styleOverrides]}>
      <HeaderMediaImage contentData={contentData} currentLevel={currentLevel} />
    </div>
  );
};

export default ContentDisplayHeaderMedia;
